var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideVocab)?_c('span',{staticClass:"jom-vocab"},_vm._l((_vm.data),function(item,index){return _c('span',{key:index},[_c('jo' + item.name,{tag:"component",attrs:{"data":item.data}}),_vm._v(_vm._s(item.name=='sup' && index==_vm.data.length-1?'\xa0\xa0\xa0\xa0':''))],1)}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6610ae4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/componentsMobile/maincontent/body/common/vocab.vue
// module id = null
// module chunks = 